/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetFleetsFleetIdOk
 */
export interface GetFleetsFleetIdOk {
    /**
     * Is free-move enabled
     * @type {boolean}
     * @memberof GetFleetsFleetIdOk
     */
    isFreeMove: boolean;
    /**
     * Does the fleet have an active fleet advertisement
     * @type {boolean}
     * @memberof GetFleetsFleetIdOk
     */
    isRegistered: boolean;
    /**
     * Is EVE Voice enabled
     * @type {boolean}
     * @memberof GetFleetsFleetIdOk
     */
    isVoiceEnabled: boolean;
    /**
     * Fleet MOTD in CCP flavoured HTML
     * @type {string}
     * @memberof GetFleetsFleetIdOk
     */
    motd: string;
}

/**
 * Check if a given object implements the GetFleetsFleetIdOk interface.
 */
export function instanceOfGetFleetsFleetIdOk(value: object): value is GetFleetsFleetIdOk {
    if (!('isFreeMove' in value) || value['isFreeMove'] === undefined) return false;
    if (!('isRegistered' in value) || value['isRegistered'] === undefined) return false;
    if (!('isVoiceEnabled' in value) || value['isVoiceEnabled'] === undefined) return false;
    if (!('motd' in value) || value['motd'] === undefined) return false;
    return true;
}

export function GetFleetsFleetIdOkFromJSON(json: any): GetFleetsFleetIdOk {
    return GetFleetsFleetIdOkFromJSONTyped(json, false);
}

export function GetFleetsFleetIdOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFleetsFleetIdOk {
    if (json == null) {
        return json;
    }
    return {
        
        'isFreeMove': json['is_free_move'],
        'isRegistered': json['is_registered'],
        'isVoiceEnabled': json['is_voice_enabled'],
        'motd': json['motd'],
    };
}

export function GetFleetsFleetIdOkToJSON(json: any): GetFleetsFleetIdOk {
    return GetFleetsFleetIdOkToJSONTyped(json, false);
}

export function GetFleetsFleetIdOkToJSONTyped(value?: GetFleetsFleetIdOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_free_move': value['isFreeMove'],
        'is_registered': value['isRegistered'],
        'is_voice_enabled': value['isVoiceEnabled'],
        'motd': value['motd'],
    };
}

